define.alias("ember-composable-helpers/helpers/flatten", "preview-grid/helpers/flatten");